<template>
  <Skeleton active :loading="skeletonLoading">
    <div>
      <div class="HotList">
        <div class="head" @click="onClickHead">
          <img src="@/assets/com/bar chart.svg" />
          <div>{{ title }}</div>
        </div>
        <Spin :spinning="loading">
          <div class="list">
            <div class="item" v-for="item in dataList" @click="onClick(item)">
              <div class="title" :title="item.title">{{ item.title }}</div>
              <div class="time">{{ dayjs(item.publishTime).format('YYYY-MM-DD') }} | (点击 {{ item.views }})</div>
            </div>
          </div>
          <br v-if="dataList.length === 0" />
          <Empty v-if="dataList.length === 0" />
        </Spin>
      </div>
    </div>
  </Skeleton>
</template>
<script setup lang="ts">
import { Skeleton, Spin, Empty } from 'ant-design-vue'
import { useRouter } from '@/hooks/useRouter'
import useList from '@/hooks/useList'
import { getHotList } from '@/api/notice'
import dayjs from 'dayjs'
import { toDetail } from '@/utils'
import useInit from '@/hooks/useInit'

const router = useRouter()

type Props = {
  /** 标题 */
  title?: string
  /** 点击标题时跳转的地址 */
  target?: string
  /** 列表所查询的`noticeTag` */
  noticeTags: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '热点',
})

const { dataList, loading, pagination, onQueryList } = useList<NoticeItem>({
  getList: getHotList,
  formatGetListQuery(query) {
    return {
      ...query,
      noticeTags: props.noticeTags,
    }
  },
})

const { loading: skeletonLoading } = useInit(dataList)

function onClickHead() {
  if (props.target) {
    router?.push(props.target)
  }
}

function onClick(item: NoticeItem) {
  toDetail(item)
}
</script>
<style lang="less" scoped>
.HotList {
  .head {
    color: #575757;
    font-size: 16px;
    line-height: 50px;
    background: #f1f1f1;
    border-bottom: 2px solid @primary;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      margin: 0 16px 0 27px;
      width: 24px;
      height: 24px;
    }
  }

  .list {
    .item {
      border-bottom: 1px solid #dfdfdf;
      padding: 18px 0 18px 0;

      .title {
        color: @primary;
        padding-bottom: 8px;
        font-size: 14px;
        transition: all 0.2s;
        cursor: pointer;
        .ellipsis();

        &:hover {
          color: @success;
        }
      }
      .time {
        color: #a0a0a0;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>
